export default {
    documents: null,
    allowedFileTypes: [],
    // allowedFileTypes: ['image/jpeg', 'image/png', 'application/pdf'],
    formFilesData: {}
}